// 複刻文化 Fuko — 合作購書通路
// 品牌中文全名：複刻文化事業有限公司

export interface StoreChannel {
  name: string;
  url: string;
  description: string;
  category?: 'reference' | 'physical' | 'digital';
}

export const storeChannels: StoreChannel[] = [
  {
    name: '崧博出版書籍資料庫',
    url: 'https://catalog.sonbook.net',
    description: '查詢正式書名、作者、ISBN、出版日期及完整書目資訊。',
    category: 'reference',
  },
  {
    name: '崧博出版官網',
    url: 'https://sonbook.net/',
    description: '崧博出版官方網站，提供品牌資訊與出版服務。',
    category: 'reference',
  },
  {
    name: '博客來',
    url: 'https://www.books.com.tw/web/sys_puballb/books/?pubid=sonbookservice1',
    description: '台灣最大網路書店，提供複刻文化出版品線上選購與宅配服務。',
    category: 'physical',
  },
  {
    name: '誠品',
    url: 'https://www.eslite.com/search?keyword=複刻文化事業有限公司&manufacturer=WyLopIfliLvmlofljJbkuovmpa3mnInpmZDlhazlj7giXQ&final_price',
    description: '誠品線上書店，提供複刻文化出版品查詢與訂購。',
    category: 'physical',
  },
  {
    name: '金石堂',
    url: 'https://www.kingstone.com.tw/bookpublish/publist/62472/',
    description: '金石堂網路書店，提供複刻文化出版品瀏覽與購買。',
    category: 'physical',
  },
  {
    name: '三民',
    url: 'https://www.sanmin.com.tw/search?pu=複刻文化',
    description: '三民網路書店，提供複刻文化出版品線上查詢與訂購。',
    category: 'physical',
  },
  {
    name: 'momo',
    url: 'https://www.momoshop.com.tw/search/複刻文化?brand=複刻文化',
    description: 'momo 購物網書籍館，提供複刻文化出版品線上選購。',
    category: 'physical',
  },
  {
    name: '蝦皮',
    url: 'https://shopee.tw/sonbook',
    description: '蝦皮購物官方賣場，提供複刻文化出版品線上購買。',
    category: 'physical',
  },
  {
    name: 'Amazon Kindle',
    url: 'https://www.amazon.com/s?k=複刻文化',
    description: 'Amazon Kindle 電子書平台，提供複刻文化數位出版品查詢與購買。',
    category: 'digital',
  },
  {
    name: 'TAAZE 讀冊',
    url: 'https://www.taaze.tw/rwd_searchResult.html?keyType%5B%5D=3&keyword%5B%5D=複刻文化',
    description: 'TAAZE 讀冊生活，提供複刻文化新書、二手書查詢與購買。',
    category: 'physical',
  },
  {
    name: '樂天 Kobo',
    url: 'https://www.kobo.com/tw/zh',
    description: '樂天 Kobo 電子書平台，提供複刻文化數位出版品瀏覽與購買。',
    category: 'digital',
  },
  {
    name: 'Pubu',
    url: 'https://www.pubu.com.tw/store/4193937',
    description: 'Pubu 電子書城，提供複刻文化數位出版品線上閱讀與購買。',
    category: 'digital',
  },
  {
    name: 'OverDrive',
    url: 'https://www.overdrive.com/publishers/複刻文化',
    description: 'OverDrive 國際數位圖書館平台，提供複刻文化電子書借閱與購買。',
    category: 'digital',
  },
  {
    name: 'MyBook',
    url: 'https://mybook.mobi/mybook/zh-TW/#',
    description: '台灣大哥大 MyBook 電子書平台，提供複刻文化數位出版品。',
    category: 'digital',
  },
  {
    name: 'Hami Book',
    url: 'https://www.hamibook.com.tw/Search/finish?keyword=複刻文化',
    description: '中華電信 Hami Book 電子書平台，提供複刻文化數位出版品查詢與購買。',
    category: 'digital',
  },
];